import { Stack, Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { useGetPatientIdentificationQuery } from "src/api/services/api";
import FileView from "src/shared/FileView";
import WhiteCard from "src/components/WhiteCard";

interface PatientIdVerificationProps {
  patientProfileId: string | undefined;
}

const PatientIdVerification = ({
  patientProfileId,
}: PatientIdVerificationProps) => {
  const { data: files } = useGetPatientIdentificationQuery(
    patientProfileId != null
      ? { profileId: patientProfileId, folderName: "identification" }
      : skipToken,
  );

  return (
    <WhiteCard
      width="320px"
      maxHeight="315px"
      gap={1}
      sx={{ overflowY: "auto" }}
    >
      <Typography variant="subtitle2">ID VERIFICATION</Typography>
      <Stack gap={1} direction="row">
        {files?.map((file) => (
          <FileView
            key={file.url}
            file={file}
            label={
              file.name.includes("front-of-card")
                ? "Patient ID"
                : "Patient Selfie"
            }
          />
        ))}
      </Stack>
    </WhiteCard>
  );
};

export default PatientIdVerification;
